import { ApiState, Paginate } from "@/store/general.types";
import { mutate } from "@/store/plugins/mutation-handler";
import { EditCitationDTO, HighlightedKeywordsDTO, MergeStudiesPayload, ResolveConflictPayload, RevertDecisionPayload, ScreeningRecordsCount, ScreeningState, StudyScreeningRecordsCount, StudyScreeningStatus } from "./screening.types";
import { Study } from "../study/study.types";
import { ScreeningOverviewDTO } from "@/views/Screening/types/screening-view.types";

export const screeningMutations = {
    GET_SCREENING_RECORDS_COUNT(state: ScreeningState, newState: ApiState<ScreeningRecordsCount>) {
        mutate(state, newState, 'getScreeningRecordsCount');
    },
    GET_STUDY_SCREENING_RECORDS_COUNT(state: ScreeningState, newState: ApiState<StudyScreeningRecordsCount>) {
        mutate(state, newState, 'getStudyScreeningRecordsCount');
    },
    GET_SCREENING_OVERVIEW_COUNT(state: ScreeningState, newState: ApiState<ScreeningOverviewDTO>) {
        mutate(state, newState, 'getScreeningOverviewCount');
    },
    GET_AWAITING_SCREENING_RECORDS(state: ScreeningState, newState: ApiState<Paginate<Study>>) {
        mutate(state, newState, 'getAwaitingScreeningRecords');
    },
    UPDATE_SCREENING_RECORDS(state: ScreeningState, study: Study) {
        // When a screening record is included or exclude then update the local state by removing the studyId
        // from awaitingScreeningRecord state.
        const awaitingScreeningRecordsState = state.getAwaitingScreeningRecords;
        const items = awaitingScreeningRecordsState.data?.items;
        const count = awaitingScreeningRecordsState.data?.totalCount;
        const studyId = study.id;
        const filteredItems = items && items.filter((item) => {
            return item.id !== studyId
        });
        if (filteredItems && count) {
            awaitingScreeningRecordsState.data = { 'items': filteredItems, 'totalCount': count - 1 }
            mutate(state, awaitingScreeningRecordsState, 'getAwaitingScreeningRecords');
        }
    },

    UPDATE_SCREENING_RECORDS_COUNT(state: ScreeningState, screeningStatus: StudyScreeningStatus) {

        const studyScreeningRecordsCountState = state.getStudyScreeningRecordsCount;
        const awaitingScreeningCount = studyScreeningRecordsCountState.data?.awaitingScreeningCount;
        const includedScreeningCount = studyScreeningRecordsCountState.data?.includedScreeningCount;
        const excludedScreeningCount = studyScreeningRecordsCountState.data?.excludedScreeningCount;
        const conflictedScreeningCount = studyScreeningRecordsCountState.data?.conflictedScreeningCount;
        const userDecisionScreeningCount = studyScreeningRecordsCountState.data?.userDecisionScreeningCount;

        if (screeningStatus === StudyScreeningStatus.PENDING && state.getStudyScreeningRecordsCount) {
            if (studyScreeningRecordsCountState.data && awaitingScreeningCount !== undefined && userDecisionScreeningCount !== undefined) {
                studyScreeningRecordsCountState.data.awaitingScreeningCount = awaitingScreeningCount - 1;
                studyScreeningRecordsCountState.data.userDecisionScreeningCount = userDecisionScreeningCount + 1;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');
        }
        else if (screeningStatus === StudyScreeningStatus.INCLUDED && state.getStudyScreeningRecordsCount) {
            if (studyScreeningRecordsCountState.data && awaitingScreeningCount !== undefined && includedScreeningCount !== undefined && userDecisionScreeningCount !== undefined) {
                studyScreeningRecordsCountState.data.awaitingScreeningCount = awaitingScreeningCount - 1;
                studyScreeningRecordsCountState.data.includedScreeningCount = includedScreeningCount + 1;
                studyScreeningRecordsCountState.data.userDecisionScreeningCount = userDecisionScreeningCount + 1;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');

        }
        else if (screeningStatus === StudyScreeningStatus.EXCLUDED && state.getStudyScreeningRecordsCount) {
            if (studyScreeningRecordsCountState.data && awaitingScreeningCount !== undefined && excludedScreeningCount !== undefined && userDecisionScreeningCount !== undefined) {
                studyScreeningRecordsCountState.data.awaitingScreeningCount = awaitingScreeningCount - 1;
                studyScreeningRecordsCountState.data.excludedScreeningCount = excludedScreeningCount + 1;
                studyScreeningRecordsCountState.data.userDecisionScreeningCount = userDecisionScreeningCount + 1;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');

        }
        else if (screeningStatus === StudyScreeningStatus.CONFLICTED) {
            if (studyScreeningRecordsCountState.data && awaitingScreeningCount !== undefined && conflictedScreeningCount !== undefined && userDecisionScreeningCount !== undefined) {
                studyScreeningRecordsCountState.data.awaitingScreeningCount = awaitingScreeningCount - 1;
                studyScreeningRecordsCountState.data.conflictedScreeningCount = conflictedScreeningCount + 1;
                studyScreeningRecordsCountState.data.userDecisionScreeningCount = userDecisionScreeningCount + 1;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');
        }
    },

    UPDATE_SCREENING_RECORDS_COUNT_ON_MARK_DUPLICATE(state: ScreeningState, study: Study) {
        // TODO: Take care of mark not duplicate case
        const studyScreeningRecordsCountState = state.getStudyScreeningRecordsCount;
        const awaitingScreeningCount = state.getStudyScreeningRecordsCount.data?.awaitingScreeningCount;
        if (awaitingScreeningCount != undefined && studyScreeningRecordsCountState.data) {
            studyScreeningRecordsCountState.data.awaitingScreeningCount = awaitingScreeningCount ? awaitingScreeningCount - 1 : 0;
            mutate(state,studyScreeningRecordsCountState,'getStudyScreeningRecordsCount');
        }
    },

    UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_MY_DECISION(state: ScreeningState, study: Study) {
        const studyScreeningCountState = state.getStudyScreeningRecordsCount;
        const awaitingScreeningCount = state.getStudyScreeningRecordsCount.data?.awaitingScreeningCount;
        const userDecisionScreeningCount = state.getStudyScreeningRecordsCount.data?.userDecisionScreeningCount;
        if (studyScreeningCountState.data && awaitingScreeningCount !== undefined && userDecisionScreeningCount !== undefined) {
            studyScreeningCountState.data.awaitingScreeningCount = awaitingScreeningCount + 1;
            studyScreeningCountState.data.userDecisionScreeningCount = userDecisionScreeningCount ? userDecisionScreeningCount - 1 : 0;
            mutate(state,studyScreeningCountState,'getStudyScreeningRecordsCount');

        }
    },
    UPDATE_MY_DECISION_SCREENING_RECORDS(state: ScreeningState, study: Study) {
        // TODO: Can we not have a single function to remove a study from list of screening records based on state path.
        const myDecisionScreeningRecordsState = state.getMyDecisionScreeningRecords;
        const items = myDecisionScreeningRecordsState.data?.items;
        const count = myDecisionScreeningRecordsState.data?.totalCount;
        const studyId = study.id;
        const filteredItems = items && items.filter((item) => {
            return item.id !== studyId
        });
        if (filteredItems != undefined && count != undefined) {
            myDecisionScreeningRecordsState.data = { 'items': filteredItems, 'totalCount': count - 1 }
            mutate(state, myDecisionScreeningRecordsState, 'getMyDecisionScreeningRecords');
        }
    },

    UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_TEAM_DECISION(state: ScreeningState, studyScreeningStatus: StudyScreeningStatus) {
        const studyScreeningRecordsCountState = state.getStudyScreeningRecordsCount;
        if (studyScreeningRecordsCountState.data) {
            const { userDecisionScreeningCount, awaitingScreeningCount, includedScreeningCount, excludedScreeningCount, resolvedScreeningCount } = studyScreeningRecordsCountState.data;
            studyScreeningRecordsCountState.data.userDecisionScreeningCount = userDecisionScreeningCount - 1;
            studyScreeningRecordsCountState.data.awaitingScreeningCount = awaitingScreeningCount + 1;
            if (studyScreeningStatus === StudyScreeningStatus.INCLUDED) {
                studyScreeningRecordsCountState.data.includedScreeningCount = includedScreeningCount ? includedScreeningCount - 1 : 0;
            } else if (studyScreeningStatus === StudyScreeningStatus.EXCLUDED) {
                studyScreeningRecordsCountState.data.excludedScreeningCount = excludedScreeningCount ? excludedScreeningCount - 1 : 0;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');
        }
    },

    UPDATE_SCREENING_RECORDS_ON_REVERT_TEAM_DECISION(state:ScreeningState , study: Study){
        const studiesByScreeningTypeStatusState = state.getStudiesByScreeningTypeStatus;
        const items = studiesByScreeningTypeStatusState.data?.items;
        const count = studiesByScreeningTypeStatusState.data?.totalCount;
        const studyId = study.id;
        const filteredItems = items && items.filter((item) => {
            return item.id !== studyId
        });
        if (filteredItems != undefined && count != undefined) {
            studiesByScreeningTypeStatusState.data = { 'items': filteredItems, 'totalCount': count - 1 }
            mutate(state, studiesByScreeningTypeStatusState, 'getStudiesByScreeningTypeStatus');
        }
    },

    UPDATE_SCREENING_RECORD_COUNT_ON_RESOLVE_CONFLICT(state: ScreeningState, studyScreeningStatus: StudyScreeningStatus) {
        const studyScreeningRecordsCountState = state.getStudyScreeningRecordsCount;
        if (studyScreeningRecordsCountState.data) {
            const { conflictedScreeningCount, includedScreeningCount, excludedScreeningCount , resolvedScreeningCount} = studyScreeningRecordsCountState.data;
            studyScreeningRecordsCountState.data.conflictedScreeningCount = conflictedScreeningCount ? conflictedScreeningCount - 1 : 0;
            studyScreeningRecordsCountState.data.resolvedScreeningCount = resolvedScreeningCount + 1;
            if (studyScreeningStatus === StudyScreeningStatus.INCLUDED) {
                studyScreeningRecordsCountState.data.includedScreeningCount = includedScreeningCount + 1;
            } else if (studyScreeningStatus === StudyScreeningStatus.EXCLUDED) {
                studyScreeningRecordsCountState.data.excludedScreeningCount = excludedScreeningCount + 1;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');
        }
    },
    UPDATE_CONFLICTED_SCREENING_RECORDS(state: ScreeningState, study: Study) {
        const conflictedStudyScreeningRecordsState = state.getConflictedStudyScreeningRecords;
        const items = conflictedStudyScreeningRecordsState.data?.items;
        const count = conflictedStudyScreeningRecordsState.data?.totalCount;
        const studyId = study.id;
        const filteredItems = items && items.filter((item) => {
            return item.id !== studyId
        });
        if (filteredItems != undefined && count != undefined) {
            conflictedStudyScreeningRecordsState.data = { 'items': filteredItems, 'totalCount': count - 1 }
            mutate(state, conflictedStudyScreeningRecordsState, 'getConflictedStudyScreeningRecords');
        }
    },

    UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_RESOLVED(state: ScreeningState, studyScreeningStatus: StudyScreeningStatus) {
        const studyScreeningRecordsCountState = state.getStudyScreeningRecordsCount;
        if (studyScreeningRecordsCountState.data) {
            const { conflictedScreeningCount, includedScreeningCount, excludedScreeningCount, resolvedScreeningCount } = studyScreeningRecordsCountState.data;
            studyScreeningRecordsCountState.data.conflictedScreeningCount = conflictedScreeningCount + 1;
            studyScreeningRecordsCountState.data.resolvedScreeningCount = resolvedScreeningCount ? resolvedScreeningCount - 1 : 0;
            if (studyScreeningStatus === StudyScreeningStatus.INCLUDED) {
                studyScreeningRecordsCountState.data.includedScreeningCount = includedScreeningCount ? includedScreeningCount - 1 : 0;
            } else if (studyScreeningStatus === StudyScreeningStatus.EXCLUDED) {
                studyScreeningRecordsCountState.data.excludedScreeningCount = excludedScreeningCount ? excludedScreeningCount - 1 : 0;
            }
            mutate(state, studyScreeningRecordsCountState, 'getStudyScreeningRecordsCount');
        }
    },

    UPDATE_RESOLVED_SCREENING_RECORDS(state: ScreeningState, study: Study) {
        const resolvedStudyScreeningRecordsState = state.getResolvedScreeningRecords;
        const items = resolvedStudyScreeningRecordsState.data?.items;
        const count = resolvedStudyScreeningRecordsState.data?.totalCount;
        const studyId = study.id;
        const filteredItems = items && items.filter((item) => {
            return item.id !== studyId
        });
        if (filteredItems != undefined && count != undefined) {
            resolvedStudyScreeningRecordsState.data = { 'items': filteredItems, 'totalCount': count - 1 }
            mutate(state, resolvedStudyScreeningRecordsState, 'getResolvedScreeningRecords');
        }

    },
    EDIT_CITATION_RECORD(state: ScreeningState, newState: ApiState<EditCitationDTO>) {
        mutate(state, newState, 'editCitationRecord');
    },
    GET_STUDIES_BY_SCREENING_TYPE_STATUS(state: ScreeningState, newState: ApiState<Paginate<Study>>) {
        mutate(state, newState, 'getStudiesByScreeningTypeStatus');
    },
    GET_MY_DECISION_SCREENING_RECORDS(state: ScreeningState, newState: ApiState<Paginate<Study>>) {
        mutate(state, newState, 'getMyDecisionScreeningRecords');
    },
    UPDATE_STUDY_SCREENING_STATUS(state: ScreeningState, newState: ApiState<void>) {
        mutate(state, newState, 'updateStudyScreeningStatus');
    },
    REVERT_STUDY_SCREENING_DECISION(state: ScreeningState, newState: ApiState<void>) {
        mutate(state, newState, 'revertStudyScreeningDecision');
    },
    REVERT_MY_DECISION_SCREENING_RECORDS(state: ScreeningState, newState: ApiState<Paginate<Study>>) {
        mutate(state, newState, 'revertMyDecisionScreeningRecords');
    },
    GET_CONFLICTED_SCREENING_RECORDS(state: ScreeningState, newState: ApiState<Paginate<Study>>) {
        mutate(state, newState, 'getConflictedStudyScreeningRecords');
    },
    GET_RESOLVED_SCREENING_RECORDS(state: ScreeningState, newState: ApiState<Paginate<Study>>) {
        mutate(state, newState, 'getResolvedScreeningRecords');
    },
    REVERT_RESOLVED(state: ScreeningState, newState: ApiState<RevertDecisionPayload>) {
        mutate(state, newState, 'revertResolved');
    },
    RESOLVE_CONFLICT(state: ScreeningState, newState: ApiState<ResolveConflictPayload>) {
        mutate(state, newState, 'resolveConflict');
    },
    MERGE_STUDIES(state: ScreeningState, newState: ApiState<MergeStudiesPayload>) {
        mutate(state, newState, 'mergeStudies');
    },
    UNMERGED_STUDIES(state: ScreeningState, newState: ApiState<MergeStudiesPayload>) {
        mutate(state, newState, 'unmergedStudies');
    },
    GET_HIGHLIGHTED_KEYWORDS(state: ScreeningState, newState: ApiState<HighlightedKeywordsDTO>) {
        mutate(state, newState, 'getHighlightedKeywords');
    },
    TOGGLE_SHOW_ABSTRACT_STATE(state: ScreeningState) {
        state.showAbstract = !state.showAbstract;
    },
    TOGGLE_KEYWORDS_HIGHLIGHTED_STATE(state: ScreeningState) {
        state.isKeywordHighlighted = !state.isKeywordHighlighted;
    },
}
